<template>
  <div v-if="gifts.length" class="container">
    <div class="gifts-window">
      <div
        class="gifts-absolute"
        :style="{
          left: touching ? -touching + 'px' : -(showPage * 100) + '%',
          width: 100 * gifts.length + '%',
          transition: hasTransition ? 'left .4s' : ''
        }"
        @touchstart="touchStart($event)"
        @touchmove="touchMove($event)"
        @touchend="touchEnd($event)"
      >
        <div
          v-for="(giftList, i) in gifts"
          :key="`page-${i}`"
          class="gift-container"
          :ref="i === 0 && `gift_container_0`"
          :style="` margin-top: ${startMargin};`"
        >
          <div
            v-for="(msg, index) in gifts[i]"
            :key="`${i}gift${index}`"
            class="one-gift pointer"
            :class="[
              selected.page === i &&
                selected.index === index &&
                msg !== 'loading' &&
                'selected',
              msg === 'loading' && 'gift-loading'
            ]"
            @click="msg && msg !== 'loading' && (selected = { page: i, index })"
          >
            <div v-if="msg && msg !== 'loading'">
              <span class="badge" v-if="msg.ownCount">{{ msg.ownCount }}</span>
              <img class="gift-img" :src="msg.imageUrl" />
              <span class="gift-name">{{ msg.name }}</span>
              <div class="gift-price" v-if="!msg.recommend">
                <span>{{ msg.paymentAmount }}</span>
                <img :src="getGoldImg()" />
              </div>
              <div class="gift-source" v-else>
                <span>
                  {{ msg.recommend }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="select-page-container">
    <div
      v-for="(a, i) in gifts"
      :key="'cirle' + i"
      class="select-page"
      :class="showPage===i&&'selected'"
      @click="showPage=i"
    />
  </div> -->
    <div class="select-page-container">
      <button
        class="last-page"
        :class="showPage === 0 && 'can-select'"
        @click="showPage !== 0 && (showPage = showPage - 1)"
      />
      <button
        class="next-page"
        :class="showPage === gifts.length - 1 && 'can-select'"
        @click="showPage !== gifts.length - 1 && (showPage = showPage + 1)"
      />
    </div>
    <div class="select-count">
      <div class="count-left">
        <img class="gold-img-1" :src="getGoldImg()" />
        <span class="asset">{{ accountInfo.diamondBalance || 0 }}</span>
        <div class="recharge pointer" @click="handleRecharge">
          <span class="text">{{$t('components_recharge_index_389')}}</span>
          <img :src="getRechargeImg()" />
        </div>
      </div>
      <div class="count-right">
        <el-popover
          placement="top"
          trigger="click"
          v-model="showSelectCount"
          popper-class="select-count-popover"
        >
          <div
            v-for="(item, index) in counts"
            class="select-count-container pointer"
            :key="'counts' + index"
            @click="changeSelectCount(item.count)"
          >
            <span class="count">{{ item.count }}</span>
            <span class="content">{{ item.name }}</span>
          </div>
          <div class="show-count pointer" slot="reference">
            <span class="count">{{ giftCount }}</span>
            <img
              :class="showSelectCount ? '' : 'rotate'"
              :src="getSelectCountImg()"
            />
          </div>
        </el-popover>
        <button class="send-gift-btn" @click="sendGift">{{$t('components_sendgifts_index_424')}}</button>
      </div>
    </div>
    <el-dialog
      :title="$t('upgrade_page_views_diamond_recharge_diamond_dialog_419')"
      :visible.sync="isPayDialog"
      width="400px"
      append-to-body
      center
      destroy-on-close
    >
      <div class="diamond-pay">
        <div class="diamond-transition">
          <span
            >{{$t('components_sendgifts_index_425')}}<img src="~@/assets/image/icons/coin.png" alt=""
          /></span>
          =
          <span>{{$t('components_sendgifts_index_426', [ isConvertRatioFloor ])}}<img
              src="~@/assets/image/icons/diamond.png"
              alt=""
          /></span>
        </div>
        <div class="diamond-pay-box">
          <el-input
            v-model.number="inputNicee"
            type="text"
            maxlength="10"
            clearable
          >
            <img slot="prefix" src="~@/assets/image/icons/coin.png" />
          </el-input>
          <el-input
            v-model="inputDiamond"
            type="number"
            maxlength="12"
            :disabled="true"
          >
            <img slot="prefix" src="~@/assets/image/icons/diamond.png" />
          </el-input>
        </div>
        <div class="pay-num">
          <span>{{$t('components_sendgifts_index_427')}}</span><span class="pay-num-item">{{ inputNicee }}</span
          ><img src="~@/assets/image/icons/coin.png" alt="" />
        </div>
        <div>
          <el-button>{{$t('upgrade_page_layout_header_42')}}</el-button>
          <el-button @click="onClickPay" :disabled="!inputNicee"
            >{{$t('upgrade_page_views_diamond_recharge_diamond_dialog_421')}}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import diamondImg from '@/assets/image/icons/diamond.png';
import rechargeImg from '@/assets/images/recharge.png';
import selectCountImg from '@/assets/images/select-count.png';
import { mapGetters } from 'vuex';
import Lottie from './components/lottie.js';

export default {
  name: 'Gifts',
  props: {
    playerUserUuid: String,
    startPadding: {
      type: String,
      default: '0'
    },
    startMargin: String,
    isMaster: {
      type: Boolean,
      default: false
    },
    success: Function
  },
  data() {
    return {
      inputNicee: 0,
      isPayDialog: false,
      touching: 0,
      hasTransition: true,
      showSelectCount: false,
      showPage: 0,
      selected: {
        page: 0,
        index: 0
      },
      giftCount: 1,
      counts: [
        {
          count: 1,
          name: i18n.t('components_sendgifts_index_428')
        },
        {
          count: 10,
          name: i18n.t('components_sendgifts_index_429')
        },
        {
          count: 99,
          name: i18n.t('components_sendgifts_index_430')
        },
        {
          count: 188,
          name: i18n.t('components_sendgifts_index_431')
        },
        {
          count: 520,
          name: i18n.t('components_sendgifts_index_432')
        },
        {
          count: 1314,
          name: i18n.t('components_sendgifts_index_433')
        }
      ],
      gifts: [new Array(8).fill('loading')]
    };
  },
  computed: {
    isConvertRatioFloor() {
      return Math.floor(this.accountInfo.convertRatio);
    },
    inputDiamond() {
      return this.accountInfo.convertRatio
        ? this.inputNicee * this.isConvertRatioFloor
        : 0;
    },
    ...mapGetters(['userInfo', 'accountInfo'])
  },
  created() {
    this.giftsLoading = true;
    this.getGiftInfo();
  },
  methods: {
    onClickPay() {
      if (!this.userInfo) {
        this.$util.Login();
      } else if (this.inputNicee <= this.accountInfo.balance) {
        this.$http
          .post('/account/convertAccount', {
            accountKind: 'Balance',
            convertAccountKind: 'Diamond',
            convertAmount: this.inputNicee,
            userUuid: this.userInfo.uuid
          })
          .then(() => {
            this.$store.dispatch('app/getUserAccount');
          });
        this.inputNicee = 0;
        this.isPayDialog = false;
      } else {
        this.$confirm({
          content: i18n.t('components_sendgifts_index_434', [this.accountInfo.balance]),
          confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_365'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.isPayDialog = false;
          this.recharge();
        });
      }
    },
    touchStart(e) {
      this.hasTransition = false;
      this.startX = e.targetTouches[0].screenX;
      this.absoluteWidth = this.$refs.gift_container_0[0].offsetWidth;
      this.touching = this.showPage * this.absoluteWidth;
    },
    touchMove(e) {
      let nowTime = new Date().getTime();
      if (!this.touchTime || nowTime - this.touchTime > 10) {
        this.touchTime = nowTime;
        let nowX = e.targetTouches[0].screenX;
        let move = this.startX - nowX;
        this.startX = nowX;
        this.touching += move;
      }
    },
    touchEnd() {
      this.hasTransition = true;
      let page = Math.round(this.touching / this.absoluteWidth);
      if (page < 0) page = 0;
      else if (page > this.gifts.length - 1) page = this.gifts.length - 1;
      this.showPage = page;
      this.touching = 0;
    },
    getGiftInfo() {
      this.giftsLoading = true;
      this.$http.get('/gift/list').then(rs => {
        this.giftsLoading = false;
        if (rs.data.length < 9) {
          this.gifts.push(rs.data);
        } else {
          let size = 8;
          let giftPages = Math.ceil(rs.data.length / size);
          let gifts = [];
          for (let i = 0; i < giftPages; i++) {
            if (i !== giftPages - 1) {
              gifts.push(rs.data.splice(0, size));
            } else {
              gifts.push(rs.data.concat(new Array(8 - rs.data.length)));
            }
          }
          this.gifts = gifts;
        }
        if (this.playAnimation) this.playAnimation();
      });
    },
    async sendGift() {
      window.fbq('track', 'InitiateCheckout');
      if (!this.userInfo) {
        this.$util.Login();
        return;
      }
      if (this.userInfo.uuid === this.playerUserUuid) {
        this.$message.error(i18n.t('components_sendgifts_index_435'));
        return;
      }
      if (this.isSending) {
        return;
      }
      let giftObj = this.gifts[this.selected.page][this.selected.index];
      let price = giftObj.paymentAmount * this.giftCount;
      if (giftObj.id === 132) {
        if (!giftObj.ownCount || giftObj.ownCount < this.giftCount) {
          try {
            await this.$confirm({
              title: '',
              message: i18n.t('components_sendgifts_index_436'),
              showCancelButton: true,
              confirmButtonText: i18n.t('upgrade_page_layout_header_41')
            });
            this.$router.push({
              path: `/christmas`
            });
            return;
          } catch (error) {
            return;
          }
        }
      } else if (giftObj.id === 131) {
        if (!giftObj.ownCount || giftObj.ownCount < this.giftCount) {
          try {
            await this.$confirm({
              title: '',
              message: `您還需要購買${this.giftCount -
                giftObj.ownCount}個聖誕鈴鐺，是否確認繼續？`,
              showCancelButton: true,
              confirmButtonText: i18n.t('upgrade_page_layout_header_41')
            });
          } catch (error) {
            return;
          }
        }
      }
      if (this.accountInfo.diamondBalance < price) {
        this.$confirm({
          content: `当前餘額：<img class="gold-img" src="${diamondImg}" />${this
            .accountInfo.diamondBalance || 0}，請您到儲值頁面先儲值再送出禮物`,
          title: i18n.t('upgrade_page_views_order_components_submit_button_364'),
          confirmButtonText: i18n.t('upgrade_page_views_order_components_submit_button_365'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          closeOnClickModal: true,
          dangerouslyUseHTMLString: true
        }).then(() => {
          location.href = `${location.origin}/wallet-info`;
        });
      } else {
        this.isSending = true;
        const { giftCount } = this;
        this.$http
          .post('/gift/send', {
            count: giftCount,
            giftId: giftObj.id,
            playerUserUuid: this.playerUserUuid
          })
          .then(() => {
            this.isSending = false;
            if (this.isMaster) {
              // window.gtag('ProfileSend', 'Gift', price)
            } else {
              // window.gtag('IMSend', 'Gift', price)
            }
            window.fbq('track', 'Purchase');
            this.$store.dispatch('app/getUserAccount');
            if (giftObj.id === 131) {
              if (giftObj.ownCount < this.giftCount) {
                giftObj.ownCount = 0;
              } else {
                giftObj.ownCount -= this.giftCount;
              }
            }
            if (giftObj.id === 132) {
              giftObj.ownCount -= this.giftCount;
            }
            this.giftCount = 1;

            if (this.success) {
              this.success({
                giftCount: giftCount,
                giftId: giftObj.id,
                giftImageUrl: giftObj.imageUrl,
                giftName: giftObj.name,
                giftAnimationUrl: giftObj.animationUrl
              });
            } else {
              this.$emit('send_gift_success', {
                giftCount: giftCount,
                giftId: giftObj.id,
                giftImageUrl: giftObj.imageUrl,
                giftName: giftObj.name,
                giftAnimationUrl: giftObj.animationUrl
              });
              Lottie({
                giftId: giftObj.id,
                basePath: giftObj.animationUrl
              });
            }
          })
          .catch(({ code }) => {
            this.isSending = false;
            switch (code) {
              case 801: {
                this.$message.error(i18n.t('components_sendgifts_index_437'));
                break;
              }
              case 433: {
                this.$message.error(i18n.t('components_sendgifts_index_438'));
                break;
              }
              case 701: {
                this.$message.error(i18n.t('components_sendgifts_index_439'));
                this.$store.dispatch('app/getUserAccount');
                break;
              }
              case 430: {
                this.$message.error(i18n.t('components_sendgifts_index_440'));
                break;
              }
              default: {
                this.$message.error(i18n.t('components_sendgifts_index_441'));
                break;
              }
            }
          });
      }
    },
    changeSelectCount(count) {
      this.giftCount = count;
      this.showSelectCount = false;
    },
    getRechargeImg() {
      return rechargeImg;
    },
    // playLottieById(id) {
    //   let giftObj
    //   const { gifts } = this
    //   for (var i in gifts) {
    //     for (var j in gifts[i]) {
    //       if (gifts[i][j].id == id) {
    //         giftObj = gifts[i][j]
    //         break
    //       }
    //     }
    //     if (giftObj) break
    //   }
    //   if (giftObj) {
    //     Lottie({
    //       giftId: giftObj.id,
    //       basePath: giftObj.animationUrl
    //     })
    //   }
    // },
    // playLottie(id) {
    //   if (this.giftsLoading) {
    //     this.playAnimation = () => {
    //       this.playLottieById(id)
    //     }
    //   } else {
    //     this.playLottieById(id)
    //   }
    // },
    getGoldImg() {
      return diamondImg;
    },
    getSelectCountImg() {
      return selectCountImg;
    },
    handleRecharge() {
      this.inputNicee = 0;
      this.isPayDialog = true;
    }
  }
};
</script>
<style lang="scss">
.gift-loading {
  background: #f6f6f6;
  border-radius: 4px !important;
}
.gold-img {
  height: 16px !important;
  vertical-align: middle;
}
.gold-counts {
  display: inline-block;
  vertical-align: middle;
  font-style: normal;
}
.select-count-popover {
  width: 106px;
  padding: 5px 0;
  border: none;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  .select-count-container {
    &:hover {
      background: #f6f6f6;
    }
    height: 32px;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .count {
      width: 30px;
      color: #fa006e;
      font-size: 12px;
      margin-right: 6px;
    }
    .content {
      font-size: 12px;
      color: #666666;
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__body {
    padding-top: 0;
  }
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #222c43;
    font-size: 20px;
    font-weight: 700;
  }
  .el-input__inner {
    border: none;
    border-radius: 80px;
    background-color: #e7e9ee;
    padding-left: 40px;
    margin: 0;
  }
  .el-button {
    border-radius: 100px;
    width: 120px;
    background-color: #e7e9ee;
    border: none;
  }
  .el-button + .el-button {
    background-color: #ffeb36;
  }
  .diamond-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .diamond-transition {
      display: flex;
      align-items: center;
      > span {
        display: flex;
        align-items: center;
      }
    }
    .diamond-pay-box {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    .pay-num {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .pay-num-item {
        font-size: 20px;
        font-weight: 600px;
        color: #f56c6c;
        padding-bottom: 2px;
      }
    }
    img {
      width: 24px;
      height: 24px;
    }
    .diamond-pay-box {
      .el-input {
        width: 150px;
        .el-input__prefix {
          top: 8px;
        }
      }
    }
  }
}
.gifts-window {
  width: 100%;
  height: 261px;
  position: relative;
  overflow: hidden;
  .gifts-absolute {
    position: absolute;
    height: 100%;
    top: 0;
    font-size: 0;
    display: flex;
    & > div {
      width: 100%;
    }
  }
}
.gift-container {
  height: 230px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  box-sizing: border-box;
  .one-gift {
    width: 81px;
    height: 110px;
    box-sizing: border-box;
    border-radius: 4px;
    margin: 7.5px 2.5px;
    border: 1px solid transparent;
    position: relative;

    & > div {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &.selected {
      border-color: #fa006e;
    }
    .badge {
      position: absolute;
      right: 0;
      top: 0;
      display: inline-block;
      box-sizing: border-box;
      min-width: 20px;
      padding: 0 3px;
      color: #fff;
      font-weight: 500;
      font-size: 12px;
      line-height: 1.4;
      text-align: center;
      background-color: #ee0a24;
      border: 1px solid #fff;
      border-radius: 999px;
    }
    .gift-img {
      height: 54px;
      margin-top: 1px;
    }

    .gift-name {
      margin: 7px 0 1px;
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      letter-spacing: -0.3px;
    }

    .gift-source {
      font-size: 12px;
      line-height: 17px;
      text-align: center;
      color: #706d6d;
      margin-top: 2px;
    }

    .gift-price {
      height: 17px;
      text-align: center;
      font-size: 0px;
      span {
        display: inline-block;
        line-height: 17px;
        font-size: 12px;
        vertical-align: middle;
        margin-right: 5px;
        color: #fa006e;
      }
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
    }
  }
}
.select-page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  // .select-page {
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background: #999999;
  //   margin: 0 4px;
  //   opacity: .3;
  //   &.selected {
  //     opacity: 1;
  //   }
  // }
  button {
    width: 22px;
    height: 22px;
    background: no-repeat center center / 100%;
  }
  .last-page {
    background-image: url('~@/assets/images/left.png');
    margin-right: 15px;
  }
  .next-page {
    background-image: url('~@/assets/images/right.png');
  }
  .can-select {
    opacity: 0.2;
  }
}
.select-count {
  height: 68px;
  margin-top: 15px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  .count-left {
    display: flex;
    align-items: center;
  }
  .gold-img-1 {
    width: 18px;
    height: 18px;
  }
  .asset {
    font-size: 14px;
    letter-spacing: -0.000319808px;
    margin-left: 5px;
    margin-right: 15px;
    color: #666666;
  }
  .recharge {
    color: #fa006e;
    font-size: 0;
    .text {
      font-size: 14px;
      display: inline-block;
      vertical-align: middle;
    }
    img {
      vertical-align: middle;
      width: 18px;
      height: 18px;
    }
  }
  .count-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .show-count {
    width: 82px;
    height: 44px;
    box-sizing: border-box;
    border: 1px solid #fa006e;
    border-radius: 22px 0 0 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    .count {
      font-size: 16px;
      margin-right: 5px;
      margin-left: 2.5px;
    }
    img {
      width: 12px;
      height: 12px;
      transition: all 0.3s;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
  .send-gift-btn {
    width: 82px;
    height: 44px;
    background: #fa006e;
    border-radius: 0 22px 22px 0;
    font-weight: 500;
    font-size: 16px;
    color: white;
  }
}
@media screen and (min-width: 600px) {
  .gifts-window {
    height: 261px;
  }
  .gift-container {
    height: 249px;
    .one-gift {
      border-radius: 4px;
      margin: 7.5px;
      &.selected {
        border-color: #fa006e;
      }

      .gift-img {
        height: 63px;
        margin-top: -1.5px;
      }

      .gift-name {
        margin: 4px 0 1px;
      }
    }
  }
  .select-count {
    height: 45px;
    .show-count {
      width: 55px;
      height: 28px;
      border-radius: 14px 0 0 14px;
      .count {
        font-size: 13px;
        margin-right: 2px;
        margin-left: 2.5px;
      }
    }

    .send-gift-btn {
      width: 55px;
      height: 28px;
      background: #fa006e;
      border-radius: 0 14px 14px 0;
      font-size: 14px;
    }
  }
  .master-send-gift {
    .gifts-window {
      height: 300px;
    }
    .gift-container {
      height: 300px;
      .one-gift {
        width: 95px;
        height: 120px;
        margin: 6px;
        .gift-img {
          height: 63px;
        }

        .gift-name {
          margin: 3px 0 2px;
          font-size: 12px;
          line-height: 17px;
        }

        .gift-price {
          height: 20px;
          span {
            font-size: 12px;
            line-height: 17px;
            margin-right: 4px;
          }
        }
      }
    }

    .select-count {
      height: 78px;
      padding: 0 20px;
      margin-top: 15px;
      .asset {
        font-size: 16px;
        letter-spacing: -0.000319808px;
        margin-right: 20px;
      }
      .recharge {
        color: #fa006e;
        font-size: 0;
        .text {
          font-size: 16px;
          font-weight: 500;
        }
      }
      .count-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .show-count {
        width: 95px;
        height: 44px;
        box-sizing: border-box;
        border: 1px solid #fa006e;
        border-radius: 22px 0 0 22px;
        .count {
          font-size: 16px;
          margin-right: 5px;
          margin-left: 2.5px;
        }
        img {
          width: 12px;
          height: 12px;
          transition: all 0.3s;
        }
        .rotate {
          transform: rotate(180deg);
        }
      }
      .send-gift-btn {
        width: 95px;
        height: 44px;
        background: #fa006e;
        border-radius: 0 22px 22px 0;
        font-weight: 500;
        font-size: 16px;
        color: white;
      }
    }
  }
}
</style>
